import { Badge } from "./Badge";

interface BuildingBlocksProps {
  blocks: string[];
}

export const BuildingBlocks = ({ blocks }: BuildingBlocksProps) => (
  <div className="flex flex-wrap gap-2">
    {blocks.map(block => (
      <Badge key={block} label={block} />
    ))}
  </div>
);
